import { useCallback } from 'react';
import { toast } from 'react-toastify';

export const useTicketNotifications = () => {
  // Função para enviar notificação manual
  const sendNotification = useCallback((message, type = 'info') => {
    toast[type](message, {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }, []);

  return {
    sendNotification,
  };
};
